import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';

import UploadReducer from './upload.reducer';

const rootReducer = combineReducers({
    form: reduxFormReducer,
    uploadFiles: UploadReducer
});

export default rootReducer; 
